export default "__VITE_ASSET__DCt56PE3__"